import moment from "moment";
import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useAppDispatch } from "../../redux";
import { deleteTimeslotAll, updateSelectCategoryPrenotation } from "../../redux/reducer/timeslotReducer";
import DatePickerTimeslot from "../common/datePickerTimeslot";
import FullCalendarTimeslot from "../common/fullcalendarTimeslot";
import ListServiceTimeslot from "../listServiceTimeslot";
import PopUpEditService from "../popUpEditService";
import PopUpDeleteTimeslotByService from "../popUpEditService/popUpDeleteTimeslotByService";
import PopUpManagerTimeslot from "./popUpManagerTimeslot";
import { HttpService } from "../../services/HttpService";
import { hasModules } from "../../utils/helpers";
import PharmaciesFilterList from "../listServiceTimeslot/PharmaciesFilterList";
import { useGetTimeslotFirstDay, useGetTimeslotFirstDoctorDay } from "../../hooks/useTimeslot";

const ManagerTimeslot = () => {
  const dispacth = useAppDispatch();
  const [date, setDate] = useState<Date>();
  const [timeslotDays, setTimeslotDays] = useState([]);
  const [monthShow, setMonthShow] = useState<Date>();
  const { rangEvent, user } = useSelector((state: any) => state.login);
  const [showManagerTimeslot, setShowManagerTimeslot] = useState(false);
  const [componentManagerTimeslot, setComponentManagerTimeslot] = useState("");
  const [idService, setIdService] = useState("");
  const [showDelete, setShowDelet] = useState(false);
  const [idEvent, setIdEvent] = useState("");
  const { eventId } = useSelector((state: any) => state.login);
  // array of categoryIds selected in the left bar
  const { filter, pharmacyFilter } = useSelector((state: any) => state.timeslot);
  const { timeslotUpdate } = useSelector((state: any) => state.timeslot);
  const [dateSelectTimeslot, setDateSelectTimeslot] = useState();
  const [onlyAssigned, setOnlyAssigned] = useState(true);

  const [timeslotAvailabilityDate, setTimeslotAvailabilityDate] = useState([{ startTime: "", endTime: "" }])
  const eventsSourceUrl = hasModules(user,'FEDERFARMA_DOCTOR') ? 
  `t4event/api/v01/federfarma/doctor/fullcalendar/timeslots`:
  `t4event/api/v01/event/${eventId}/fullcalendar/timeslots`;
  const [internalServiceNames, setInternalServiceNames] = useState<null | [any]>(null);
  const { categoryPrenotation } = useSelector((state: any) => state.timeslot);

  // Move to the first available day.
  const { data: firstDay } = useGetTimeslotFirstDay(
    eventId,
    filter,
    true, // future
    !hasModules(user, 'FEDERFARMA_DOCTOR'), // Active only for Pharmacist.
  )
  const { data: firstDoctorDay } = useGetTimeslotFirstDoctorDay(
    pharmacyFilter,
    onlyAssigned,
    hasModules(user, 'FEDERFARMA_DOCTOR'), // Active only for Doctor.
  )
  const [hasSetInitialDate, setHasSetInitialDate] = useState(false);
  useEffect(() => {
    // Set the date, from firstDay, only one time.
    const referralDay = firstDay || firstDoctorDay // Only one active, based on role (Pharmacist or Doctor).
    if (referralDay && !hasSetInitialDate) {
      const parsed = moment(referralDay);
      if (parsed.isValid()) {
        const parsedDate = parsed.toDate()
        setDate(parsedDate); // Move DatePickerTimeslot and FullCalendarTimeslot to the date.
        setMonthShow(parsedDate); // Load timeslot days for DatePickerTimeslot.
        setHasSetInitialDate(true); // Prevent further changes, it's just a one time init.
      }
    }
  }, [firstDay, firstDoctorDay, hasSetInitialDate]);

  /**
   * Click on a timeslot in calendar, open edit interface.
   * @param arg Fullcalendar arg, contains event details.
   */
  const eventClick = (arg: any) => {
    setShowManagerTimeslot(true);
    setIdEvent(arg.event.extendedProps.timeslotId); // NOTE!! TimeslotId!! Not Event ID!!
    setComponentManagerTimeslot("ViewTimeslot");
  }

  const OpenCreteTimeslot = () => {
    setShowManagerTimeslot(true);
    dispacth(updateSelectCategoryPrenotation(""))
    setComponentManagerTimeslot("CreateTimeslot");
  }
  const dateClick = (info: any) => {
    setDateSelectTimeslot(info.date);
    let day = moment(info.date);

    setTimeslotAvailabilityDate([{ startTime: day.format("HH:mm"), endTime: day.add(1, 'hours').format("HH:mm") }])
    OpenCreteTimeslot();
  }
  const clickServiceSettings = (id: any) => {
    setIdService(id)


  }
  const clickServiceCreateTimeslot = (id: any) => {
    setShowManagerTimeslot(true);
    dispacth(updateSelectCategoryPrenotation(id))
    setComponentManagerTimeslot("CreateTimeslot");
  }

  const closePopUp = () => {
    setIdService("")
  }

  const deleteAllTimeslot = async () => {
    await dispacth(deleteTimeslotAll());
    setShowDelet(false)
  }

  const loadTimeslotDays = async () => {
    let startDate = moment(monthShow).startOf('month').format("YYYY-MM-DD");
    let endDate = moment(monthShow).endOf('month').format("YYYY-MM-DD");
    const params = [
      `startDate=${startDate}`,
      `endDate=${endDate}`
    ]
    
    if(hasModules(user,'FEDERFARMA_DOCTOR')){
      params.push(...pharmacyFilter.map((id: string) => `eventIds[]=${id}`));
      if(onlyAssigned){
        params.push(`onlyAssigned=${onlyAssigned}`)
      }
    }else{
      params.push(`categories=${filter}`)
    }

    let result:any = ''
    if(hasModules(user,'FEDERFARMA_DOCTOR')){
       result = await HttpService.get(`${process.env.REACT_APP_API}/t4event/api/v01/federfarma/doctor/timeslot/days?${params.join('&')}`);
    }else{
       result = await HttpService.get(`${process.env.REACT_APP_API}/t4event/api/v01/event/${eventId}/timeslot/days?${params.join('&')}`);
    }
   
    if (result.status === 200) {
      setTimeslotDays(result.data)
    }
  }

  const initInternalServiceName = async (serviceNamesDisabled: [string]) => {
    const { data } = await HttpService.get(`${process.env.REACT_APP_API}/t4event/api/v01/settings/internal-timeslot-names`)
    setInternalServiceNames(data.map((internalServiceName: any) => {
      return {
        value: internalServiceName,
        label: internalServiceName,
        disabled: ((serviceNamesDisabled.includes(internalServiceName)) ? true : false)
      }
    }));
  }

  const uploadInternalServiceName = async (serviceNamesDisabled: [string]) => {
    const newInternalServiceNames: any = internalServiceNames?.map((internalServiceName: any) => {
      return {
        value: internalServiceName.value,
        label: internalServiceName.label,
        disabled: ((serviceNamesDisabled.includes(internalServiceName.value)) ? true : false)
      }
    })
    setInternalServiceNames(newInternalServiceNames);
  };
  const loadInternalServiceName = async () => {
    let serviceNamesDisabled = categoryPrenotation.map((service: any) => { return service.name });
    if (internalServiceNames === null) {
      initInternalServiceName(serviceNamesDisabled)
    }
    else {
      uploadInternalServiceName(serviceNamesDisabled)
    }
  }


  useEffect(() => {
    loadTimeslotDays()
  }, [monthShow, filter, pharmacyFilter, timeslotUpdate, onlyAssigned])

  useEffect(() => {
    loadInternalServiceName();
  }, [categoryPrenotation])
  
const isDoctor = hasModules(user,'FEDERFARMA_DOCTOR') ? true : false
  return (
    <>
      <div className="Section">
        <div className="row m-0">
          <div className="col-lg-3 pt-3">
            <DatePickerTimeslot minDate={rangEvent?.startDate} maxDate={rangEvent?.endDate} setMonthShow={setMonthShow} highlights={timeslotDays} date={date} handleChange={setDate} />
           {
            isDoctor
            ? <PharmaciesFilterList clickOnlyAssigned={setOnlyAssigned} onlyAssigned={onlyAssigned} />
            : <ListServiceTimeslot clickServiceEdit={clickServiceCreateTimeslot} clickServiceSettings={clickServiceSettings} />
           }
            
          </div>
          <div className="col-lg-9">
            <FullCalendarTimeslot
              typeCalendar="managerTimeslot"
              inizialDate={date}
              eventClick={eventClick}
              dateClick={!isDoctor ? dateClick : ()=>{} }
              eventsSourceUrl={eventsSourceUrl}
              onlyAssigned={onlyAssigned}
              ids={isDoctor ? pharmacyFilter: filter}
              idsParamKey={isDoctor ? "eventIds[]": "categoryIds[]"}
            />

          </div>
        </div>

      </div>
      <PopUpDeleteTimeslotByService
        handleCloseSecondary={() => (setShowDelet(false))}
        handleClosePrimary={() => (deleteAllTimeslot())}
        closeModal={() => (setShowDelet(false))}
        show={showDelete} />

      <PopUpEditService
        internalServiceNames={internalServiceNames}
        closeModal={closePopUp}
        id={idService}
        show={(idService !== "")}
      />
      <PopUpManagerTimeslot
        idEvent={idEvent}
        dateSelect={dateSelectTimeslot}
        timeslotAvailabilityDate={timeslotAvailabilityDate}
        showComponent={componentManagerTimeslot}
        closePopUp={() => (setShowManagerTimeslot(false))}
        show={showManagerTimeslot}
      />
    </>

  )
}

export default ManagerTimeslot